import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useApisAnalyticsPlansKpiTermsIndex,
  useDateRange,
  useMultiDivisionMultiSectionDropdown,
  useProvidersCurrentEmployee,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { AnalyticsKpiTermsTemplate } from "~/components/templates";

const today = new Date();

export const AnalyticsPlansKpiTermsIndex: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const breadCrumbItems = [
    {
      label: "KPI・KGI分析",
      href: "/analytics_plans/kpi_terms",
    },
  ];

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
  } = useMultiDivisionMultiSectionDropdown({
    selectableDivisions: currentEmployee?.businessDivisions,
    selectableSections: currentEmployee?.businessSections,
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      formattedEndDate,
      monthArray,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const { data, isLoading } = useApisAnalyticsPlansKpiTermsIndex({
    params: {
      businessDivisionIds: selectedDivisions.map((division) => division.id),
      businessSectionIds: optionSelectedSections.map((section) => section.id),
      fromDate: formattedStartDate || undefined,
      toDate: formattedEndDate || undefined,
    },
    config: {
      enabled: !!(formattedStartDate && formattedEndDate),
    },
  });

  return (
    <>
      <EmployeeLayout
        withRightSidebar={false}
        breadCrumbItems={breadCrumbItems}
      >
        <EmployeeLayoutMainContent withRightSidebar={false}>
          <AnalyticsKpiTermsTemplate
            formattedStartDate={formattedStartDate}
            formattedEndDate={formattedEndDate}
            selectedDivisions={selectedDivisions}
            optionSelectedSections={optionSelectedSections}
            data={data}
            isLoading={isLoading}
            onChangeDateRange={onChangeDateRange}
            onDivisionChange={onDivisionChange}
            onSectionChange={onSectionChange}
            selectableDivisions={selectableDivisions}
            optionSelectableSections={optionSelectableSections}
            startDate={startDate}
            endDate={endDate}
            selectedDropdownSections={optionSelectedSections}
            monthArray={monthArray}
          />
        </EmployeeLayoutMainContent>
      </EmployeeLayout>
    </>
  );
};
